import React from 'react';

import Icon from '../icon';
import Bison from '../icon/bison.icon';

const Footer = () =>
  (<footer className="c-footer">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="c-footer-content">
            <a href="https://www.bisonstudio.co" target="_blank" className='h4 c-light c-link-light d-inline-flex align-items-center'>
              <span className='mr-2'>Made by Bison Studio</span>
              <Icon icon={Bison} width={34} height={34} fill={'#fff'} />
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js